import React, { Component } from 'react';
import cx from 'classnames';
import { FILTERS } from './constants';

import Spinner from 'components/common/Spinner/Spinner';

import Input from './Input';
import Filters from './Filters';
import { Regions, SubRegions, Buildings, Streets } from './Content';
import { filtersPlaceholder } from './constants';
import s from './style';

import iconCross from 'assets/images/icons/cross.svg';
import nothingFound from 'assets/images/nothingfound.png';
import { hasRegionsInside } from './helpers';
import { withTranslation } from 'react-i18next';
import { gaEvent, trackGA } from '../../services/ga';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';

class SearchFullscreen extends Component {
  componentDidUpdate(prevProps) {
    const { searchValue, isFetched, regions, subregions, buildings, streets, profile } = this.props;

    if (prevProps.isFetched === false && isFetched && searchValue.length >= 2) {
      const totalResults = regions.length + subregions.length + buildings.length + streets.length;

      const debouncedSearchEvent = debounce(() => {
        trackGA(gaEvent.searchInput({
          eventLabel: totalResults ? `${totalResults}_results` : 'nichego_ne_naideno',
          eventContent: totalResults,
          eventContext: searchValue,
          user_id: profile.id
        }));
      }, 3000);

      debouncedSearchEvent();
    }
  }

  getResulsByFilter() {
    const { filter, regions, subregions, buildings, streets } = this.props;
    switch (filter) {
      case FILTERS.ALL:
        return regions.length || subregions.length || buildings.length || streets.length;
      case FILTERS.REGIONS:
        return regions.length;
      case FILTERS.SUB_REGIONS:
        return subregions.length;
      case FILTERS.BUILDINGS:
        return buildings.length;
      case FILTERS.STREETS:
        return streets.length;
      default:
        return null;
    }
  }

  render() {
    const {
      searchValue,
      setFilter,
      filter,
      isLoading,
      regions,
      subregions,
      buildings,
      streets,
      closeModal,
      isFetched,
      t,
      profile
    } = this.props;

    const isUserStartsSearching = !!searchValue.length;
    let areResults = this.getResulsByFilter();

    const classes = cx(s.root, {
      [s.withContent]: isUserStartsSearching
    });
    const defaultContentProps = {
      highlight: searchValue,
      closeModal
    };
    const isFiltersCanBeBlocked = isFetched && !!searchValue.length;

    return (
      <div className={classes}>
        <div
          className={s.close}
          onClick={() => {
            closeModal();
            trackGA(gaEvent.searchButtonsClick({
              eventLabel: 'zakryt',
              user_id: profile.id
            }));
          }}
        >
          <img src={iconCross} alt="" />
        </div>
        <div className={s.searchAndFilters}>
          <Input
            defaultValue={searchValue}
            placeholder={filtersPlaceholder.get(filter)}
            className={s.searchInput}
            autofocus={true}
          />
          <Filters
            setFilter={setFilter}
            filter={filter}
            areRegionsBlocked={isFiltersCanBeBlocked ? (regions.length === 0 || hasRegionsInside(regions) === false) : false}
            areSubregionsBlocked={isFiltersCanBeBlocked ? subregions.length === 0 : false}
            areBuildingsBlocked={isFiltersCanBeBlocked ? buildings.length === 0 : false}
            areStreetsBlocked={isFiltersCanBeBlocked ? streets.length === 0 : false}
            isUserStartsSearching
          />
        </div>
        {isUserStartsSearching &&
          <div className={cx(s.contentWrapper, 'custom-scrollbar')}>
            <Spinner
              isLoading={isLoading && isUserStartsSearching}
              className={s.spinner}
              noFadeIn
            >
              {areResults ?
                <div className={s.content}>
                  <Buildings
                    name={t('components.searchFullscreen.buildings')}
                    items={buildings}
                    isShown={FILTERS.BUILDINGS === filter || FILTERS.ALL === filter}
                    {...defaultContentProps}
                  />
                  <Regions
                    name={t('components.searchFullscreen.areas')}
                    items={regions}
                    isShown={FILTERS.REGIONS === filter || FILTERS.ALL === filter}
                    {...defaultContentProps}
                  />
                  <SubRegions
                    name={t('components.searchFullscreen.neighborhoods')}
                    items={subregions}
                    isShown={FILTERS.SUB_REGIONS === filter || FILTERS.ALL === filter}
                    {...defaultContentProps}
                  />
                  <Streets
                    name={t('components.searchFullscreen.streets')}
                    items={streets}
                    isShown={FILTERS.STREETS === filter || FILTERS.ALL === filter}
                    {...defaultContentProps}
                  />
                </div>
                :
                isFetched ? <div className={s.notFound}>
                  <img src={nothingFound} alt={t('components.searchFullscreen.emptyResults')} className={s.notFoundImage} />
                  <p className={s.notFoundTitle}>
                    {t('components.searchFullscreen.emptyResults')}
                  </p>
                  <p className={s.notFoundSubTitle}>
                    {t('components.searchFullscreen.emptyResultsDescription')}
                  </p>

                </div> : null
              }
            </Spinner>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile
});

export default connect(
  mapStateToProps
)(withTranslation()(SearchFullscreen));



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/SearchFullscreen.js